<template>
  <component :is="component">
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AuthStore from "@/store/AuthStore"
import PublicLayout from "@/layout/PublicLayout.vue"
import DefaultLayout from "@/layout/DefaultLayout.vue"

const component = computed(() => {
  return AuthStore.module.isAuthorized ? DefaultLayout : PublicLayout
})
</script>
